// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tlm-divider{display:block;flex:1 1 0px;height:0;max-height:0;max-width:100%}.tlm-divider.is-default{border:solid;border-color:var(--v-gray-lighten1);border-width:thin 0 0;transition:inherit}.tlm-divider.is-gradient-secondary{border-image-slice:1;border-image-source:linear-gradient(90deg,#fff,#fff4f9 20%,#ffdfee 30%,#ffcae3 50%,#ffdfee 70%,#fff4f9 80%,#fff,#fff);border-style:solid;border-width:1.5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
